import { setLocalStorage } from "./localStorage";

let ls: Record<string, string>;

try {
  ls = window.localStorage;
} catch (e) {
  console.log(e)
  ls = {};
}

setLocalStorage({
  set:    (key: string, value: string) => ls[key] = value,
  get:    (key: string) => ls[key],
  remove: (key: string) => delete ls[key],
});